import axios from 'axios';
import { mutate } from 'swr';

import { Notistack } from '@shared/components/Notistack/Notistack';
import { SERVICES } from '@shared/constants/apiConfig';
import { statesList } from '@shared/constants/statesList';
import { getError } from '@shared/utils/helpers';

import { TState } from '../../interfaces';

const url = `/${SERVICES.LENDER}/lenders/`;

export const requestCreateBureau = (lenderId: string, bureau: TState) => {
  const path = `${url}${lenderId}/stateRule`;
  return mutate(`${url}${lenderId}`, async() => {
    try {
      await axios.put(path, {
        ...bureau,
        zips: String(bureau.zips).split(', '),
      });
      Notistack.successMessage('State Rules - Created Successfully');
    } catch (err) {
      Notistack.generalError(getError(err));
    }
  });
};

export const requestUpdateBureau = (lenderId: string, bureau: TState) => {
  const path = `${url}${lenderId}/stateRule`;
  return mutate(`${url}${lenderId}`, async() => {
    try {
      await axios.patch(path, {
        ...bureau,
        stateName: statesList.find((state) => state.value === bureau.state)?.label,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        zips: (bureau?.zips as any)?.split(', '),
      });
      Notistack.successMessage('State Rules - Updated Successfully');
    } catch (err) {
      Notistack.generalError(getError(err));
    }
  });
};

export const requestDeleteBureau = (lenderId: string, bureauId = '') => {
  const path = `${url}${lenderId}/stateRule/${bureauId}`;
  return mutate(`${url}${lenderId}`, async() => {
    try {
      await axios.delete(path);
      Notistack.successMessage('State Rules - Deleted Successfully');
    } catch (err) {
      Notistack.generalError(getError(err));
    }
  });
};
